import service from '@/services'

export default {
  methods: {
    async clearExportedFile(filename) {
      try {
        const config = {
          url: '/clear-export',
          method: 'get',
          params: {
            filename,
          },
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (e) {
        if (e.response && e.response.data) {
          const blob = e.response.data
          const text = await blob.text()
          const errorJson = JSON.parse(text)

          return Promise.reject(errorJson)
        }
        return Promise.reject(e)
      }
    },
    async printLaporan(params) {
      try {
        const config = {
          url: '/excel-rekap-dropping',
          method: 'get',
          params,
          responseType: 'blob',
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        return Promise.resolve(response)
      } catch (e) {
        if (e.response && e.response.data) {
          const blob = e.response.data
          if (blob instanceof Blob) {
            const text = await blob.text()
            try {
              return Promise.reject(JSON.parse(text))
            } catch (parseErr) {
              return Promise.reject(e)
            }
          }
          return Promise.reject(e.response.data)
        }
        return Promise.reject(e)
      }
    },
  },
}
